import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import visigalogo from "../assets/visigalogo.png";
import hailmary3 from "../assets/hailmary3.png";
import axiosInstance from "../AxiosInstance";

const Staff = () => {
  const { t } = useTranslation();
  const [organizationData, setOrganizationData] = useState([]);

  useEffect(() => {
    const fetchOrganizationMember = async () => {
      try {
        const response = await axiosInstance.get("/files");
        setOrganizationData(response.data);
      } catch (error) {
        console.error("Failed to fetch organizationMembers data:", error);
      }
    };

    fetchOrganizationMember();
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
      
      {/* Left Section (Logo) */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("alevel.schoolName")}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
            {t("alevel.schoolSub")}
          </span>
        </h1>
        <img
          src={visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Section (Staff Data) */}
      <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5 dark:bg-gray-800 dark:text-gray-100">
        <h1 className="text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide">
          {t("staff.title")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("staff.subtitle")}
          </span>
        </h1>

        <p className="mt-4 text-lg lg:text-center text-neutral-900 dark:text-gray-100 w-full">
          {t("staff.content")}
        </p>

        {organizationData
          .filter((org) => org.title === "STAFFS")
          .map((organization) => (
            <div key={organization.id} className="flex flex-col items-center mt-6">
              <img
                className="rounded-md border border-neutral-300"
                src={organization.photoUrl}
                alt={organization.name || "Staff Member"}
                style={{
                  width: "19cm",
                  height: "10cm",
                  objectFit: "cover",
                }}
              />
              
            </div>
          ))}
      </div>

      {/* Right Section (Image + Quote) */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("alevel.motherText")}
        </p>
      </div>
    </div>
  );
};

export default Staff;
